var exports = {
  "iT": "commentsSection__BmEWcP",
  "LE": "commentsHeading__sf6fHU",
  "OR": "danger__-hEvA9",
  "Ti": "commentsList__0w_JrR",
  "Dx": "commentItem__dI3sc2",
  "as": "commentLabel__s0IzHx",
  "rq": "commentFilename__bLvclA",
  "Np": "commentDivider__SZeouh",
  "vc": "commentCheckbox__dwSgi8",
  "$t": "commentMessage__wLUJpV",
  "qb": "suggestionDiff__4dfkFZ",
};

module.exports = exports;
